import React from 'react';
import PropTypes from 'prop-types';

import { loadProvider } from '../modules/Api';

import AvatarIcon from './AvatarIcon';

/**
 * Creates an avatar icon circle for a pro or show their initials.
 *
 * ```
 *   <ProAvatarIcon providerId={provider.id} />
 * ```
 */
export default class ProAvatarIcon extends React.Component {
  static propTypes = {
    providerId: PropTypes.any,
    sizeClass: PropTypes.string,
    dimension: PropTypes.string,
    componentClassName: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    providerId: null,
    sizeClass: 'normal',
    dimension: '90x90',
    componentClassName: null,
    className: null,
  };

  state = {
    name: '',
    avatarUrl: null,
  };

  unmounted = false;

  componentDidMount() {
    this.loadProviderIcon();
  }

  componentDidUpdate(prevProps) {
    if (this.props.providerId && this.props.providerId !== prevProps.providerId) {
      this.loadProviderIcon();
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  /**
   * Load the provider and set the avatar image.
   */
  async loadProviderIcon() {
    if (!this.props.providerId) {
      return;
    }
    const {
      dimension,
    } = this.props;

    loadProvider(this.props.providerId)
      .then(pro => {
        if (this.unmounted) { // prevent setting state after unmounting
          return;
        }
        let avatar = null;
        if (pro.profile_photo) {
          avatar = `${pro.profile_photo}_${dimension}.jpg`;
        }
        this.setState({
          name: pro.name,
          avatarUrl: avatar,
        });
      });
  }

  render() {
    return (
      (this.props.providerId !== null) && (
        <AvatarIcon
          icon={this.state.avatarUrl}
          name={this.state.name}
          sizeClass={this.props.sizeClass}
          componentClassName={this.props.componentClassName}
          className={this.props.className}
        />
      )
    );
  }
}
